import { SAVE_CONFIG } from "../actionTypes/config";

export const saveAppConfig = (data) => {
  return { type: SAVE_CONFIG, data };
};
